import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./UI/view-models/register-funnels/funnels.module').then(
        (m) => m.FunnelsModule
      ),
  },
  {
    path: 'decline',
    loadChildren: () =>
      import('./UI/view-models/decline/decline.module').then(m => m.DeclineModule),
  },  
  { path: 'decline-v2', redirectTo: 'decline/v2', pathMatch: 'full' },
  {
    path: 'static',
    loadChildren: () =>
      import('./UI/view-models/static-pages/static-pages.module').then(m => m.StaticPagesModule)
  },
  { path: 'terms', redirectTo: 'static/terms', pathMatch: 'full' },
  { path: 'privacy', redirectTo: 'static/privacy', pathMatch: 'full' },
  { path: 'intro-welcome-email', redirectTo: 'static/intro-welcome-email', pathMatch: 'full' },
  { path: 'redirect-already-exists-user', redirectTo: 'static/redirect-already-exists-user', pathMatch: 'full' },
  { path: 'for-you', redirectTo: 'static/for-you', pathMatch: 'full' },
  {
    path: 'contact',
    loadChildren: () =>
      import('./UI/view-models/contact-us/contact-us.module').then(m => m.ContactUsModule)
  },
  { path: '**', redirectTo: '' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
